import React from "react";
import { MessageCircle } from "lucide-react";
import { whatsappLink, SITE } from "@/data/site";

export default function WhatsappFloat() {
  return (
    <a
      href={whatsappLink()}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label={`WhatsApp ${SITE.whatsappNumber}`}
      className="fixed bottom-20 lg:bottom-24 right-6 z-50 group inline-flex items-center gap-3 bg-brand-accent text-black font-semibold pl-4 pr-5 py-3.5 shadow-2xl hover:bg-brand-accentHover transition-all"
    >
      <MessageCircle size={20} />
      <span className="hidden sm:inline text-sm">WhatsApp</span>
    </a>
  );
}
